import React, { useState,useRef , useEffect } from 'react';
import 'react-simple-keyboard/build/css/index.css';
import Styles from './giftCard.module.scss';
import cn from 'classnames';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { flowType } from '@utility/userInfo';
import CustomKeyboard from '@components/common/CustomKeyboard/index';
import { APP_CONFIG } from '@constants';
import { getObjectValue, urlSearchParams } from '../../utility/utills';
import Webcam from "react-webcam";
import Modal from '../common/Modal/index';

const giftCard = (props) => {
  const {
    // type,
    isSecurityCode,
    onSubmit,
    giftBalance,
    giftBalanceAmt,
    giftCardPayment,
    paymentAmount,
    giftCardSupportsSwipe,
    openCardPopUp,
    handleGiftCancel,
    setPaymentType,
    tableData,
    setNotification,
    giftCardMethods,
    setGiftBalance,
    setTipAmount,
    authInfo
  } = props;
  const [activeElement, setActiveElement] = useState('cardNumber');
  const [inputs, setInputs] = useState('');
  const [typed, setTyped] = useState({});
  const currencySymbol = LABEL().CURRENCY_SYMBOL;
  const [swipedDown, setSwipedDown] = useState(false);
  const [error, setError] = useState('');
  const [isWebCam, setIsWebCam] = useState(false);
  const keyboard = useRef(null);
  const ref = useRef(null);
  const isPaymentTerminal = flowType() === 'paymentTerminal';
  const giftCardImageUrl = getObjectValue(() => authInfo.giftCardImageUrl, null);
  const isServerApp = flowType() === 'serverApp';

  useEffect(() => {
    setActiveElement(!giftBalance ? activeElement : 'giftCard');
    if (paymentAmount) {
      setInputs({
        ...inputs,
        giftCard: `${Number(paymentAmount).toFixed(2)}`,
      });
      setTyped({
        ...typed,
        giftCard: `${Number(paymentAmount).toFixed(2)}`,
      });
    }
  }, [giftBalance, swipedDown]);


  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setSwipedDown(false);
    }
  };

  const onClickBtn = (e) => {
    setError('');
    setTyped(
      e === '{bksp}'
        ? { ...typed, [activeElement]: typed[activeElement]?.slice(0, -1) }
        : {
          ...typed,
          [activeElement]: typed[activeElement]
            ? typed[activeElement].concat(e)
            : ''.concat(e),
        }
    );
    const value = e === '{bksp}'
      ? { ...typed, [activeElement]: typed[activeElement]?.slice(0, -1) }
      : {
        ...typed,
        [activeElement]: typed[activeElement]
          ? typed[activeElement].concat(e)
          : ''.concat(e),
      };
    setInputs({
      ...inputs,
      [activeElement]: value[activeElement],
    });
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);


  const handleBlur = () => {
    if (document.querySelector('#cardNumber')) {
      document.querySelector('#cardNumber').blur();
    }
    if (document.querySelector('#securityCode')) {
      document.querySelector('#securityCode').blur();
    }
  };

  const handleBlurForGift = () => {
    document.querySelector('#giftCard').blur();
  };

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: '',
    });
    setTyped({
      ...typed,
      [data]: '',
    });
  };

  const handleChangeInput = (data) => {
    setSwipedDown(true);
    if (keyboard.current) {
      keyboard.current.setInput(inputs[data], data);
    }
  };
  const validate = () => {
    const giftCardAmount = Number(inputs?.giftCard);
    let giftError = '';
    if (!giftCardAmount) {
      giftError = 'Enter amount more than 0';
    } else if (
      +(paymentAmount).toFixed(2) < +(giftCardAmount).toFixed(2)
      || Number(giftCardAmount) === 0
    ) {
      giftError = 'Enter the correct total amount';
    } else if (Number(giftBalance) < Number(giftCardAmount)) {
      giftError = 'Entered amount should be less than balance';
    }
    setError(giftError);
    if (giftError.length === 0) {
      setError('');
      giftCardPayment(giftCardAmount);
    }
  };

  const closeKeyboard = () => {
    setSwipedDown(false);
  };

  const getInput = (key) => {
    return inputs[key];
  };

  const handleDisable = () => {
    return (
      !inputs?.cardNumber ||
      (isSecurityCode && !inputs?.securityCode)
    );
  };

  const handleDisableApplyButton = () => {
    return !(giftBalanceAmt && paymentAmount);
  };

  const handleDisableGiftCard = () => {
    return !inputs?.giftCard;
  };

  const handleBackButton = () => {
    const resetValues = () => {
      setGiftBalance(0);
      window.sessionStorage.removeItem('tipAmt');
      setTipAmount(0);
    };

    if (urlSearchParams('type') === 'stage') {
      return {
        isShow: true,
        url: () => {
          resetValues();
          props.history.replace(`${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`);
        }
      };
    }

    if (urlSearchParams('source') === 'stageSplit') {
      return {
        isShow: true,
        url: () => {
          resetValues();
          setPaymentType(2);
          props.history.replace(
            `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=2&type=payType&source=stageSplit`
          );
        }
      };
    }

    return {
      isShow: true,
      url: () => {
        resetValues();
        setPaymentType(2);
        props.history.replace(
          `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=2&type=payType`
        );
      }
    };
  };

  const imageSubmit = (jsonToSend) => {
    props
      .giftCardImages(JSON.stringify(jsonToSend))
      .then((res) => {
        setInputs({
          giftCard: '',
          cardNumber: res.accountNumber,
          securityCode: res.securityCode
        });
      })
      .catch((err) => {
        setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const videoConstraints = {
    width: 320,
    height: 200,
    facingMode: 'environment',
  };

  const WebcamCapture = () => (
    <Webcam
      audio={false}
      height={350}
      screenshotFormat="image/jpeg"
      width={500}
      videoConstraints={videoConstraints}
    >
      {({ getScreenshot }) => (
        <button
          type="button"
          onClick={() => {
            // const imageSrc = getScreenshot()
            setIsWebCam(false);
            const jsonToSend = {
              bytes: getScreenshot().split('base64,')[1],
            };
            imageSubmit(jsonToSend);
          }}
          style={{ position: 'relative', bottom: '0vh', width: '100%' }}
          className="border-0 btn btn-primary"
        >
          Capture photo
        </button>
      )}
    </Webcam>
  );

  return !giftBalance ? (
    <div ref={ref} className={cn(!isPaymentTerminal?'ml-4':'',"col-11 w-150 p-0")}>
      { (
        <div
          className="position-fixed text-primary od-text-primary"
          style={{ left: '5px', top: 0, zIndex: '999' }}
        >
          <i
            role="presentation"
            className="fa fa-arrow-left fs-30"
            aria-hidden="true"
            onClick={() => handleBackButton().url()}
          />
        </div>
      )}
      <div className={cn('p-1 h-85')}>
        {swipedDown && (
          <div
            className={cn(
              'p-1 od-border-secondary',
              cn('w-100', Styles.paymentTerminal)         
            )}
          >
              {/* <div role="presentation" className={cn('col-12 p-0 text-right', Styles.arrow)} onClick={() => setSwipedDown(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-caret-down-fill od-text-primary text-primary" viewBox="0 0 16 16">
                  <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                </svg>
              </div> */}
              <CustomKeyboard
                onClickBtn={(e) => onClickBtn(e)}
                type="number"
                typed={typed[activeElement] || ''}
                closeKeyboard={closeKeyboard}
                btnSize="btn"
                customClass="fs-30 background-primary od-app-background-color"
                maxLength={30}
              />
          </div>
        )}
        {giftCardImageUrl !== null ?  (<div className={cn(
                'p-0 fs-22 large-input row justify-content-center', isPaymentTerminal ? 'ml-10' : null)}
               > <img src={giftCardImageUrl} alt= "giftCardImage" width={500}  height={isPaymentTerminal ? 70 : 142}/> </div>) : <div className={cn(
                'p-0 fs-22 large-input row justify-content-center', isPaymentTerminal ? 'ml-10' : null)} >  {authInfo?.imageUrl !== '' && <img src={authInfo?.imageUrl} width={500}  height={isPaymentTerminal ? 70 : 142} alt="gift-card" />} </div> }
        {giftCardSupportsSwipe && (
            
            <div className="d-flex mt-3 flex-column align-items-center pt-10 col-12" style={{height: '10vh'}}>
              <button
                type="submit"
                className={cn("col-12 btn70 btn btn-primary btn-ripple od-btn-primary text-uppercase", Styles.divForPayment)}
                style={{height: '11vh', fontSize: isServerApp? "30px" :"1.8rem"}}
                onClick={() => {
                  openCardPopUp();
                  setSwipedDown(false);
                }}
              >
                {LABEL().SWIPE_CARD}
              </button>
              {/* <div className="pt-15">OR</div> */}
            </div>
          )}
        {giftCardSupportsSwipe && <div className="my-2 fs-30 col-12 text-center"> <span> OR </span></div>}
        <div className="col-12 mb-1 py-2 mx-0 position-relative">

          <div className={cn('d-flex flex-row align-items-center ')}>
            <div
              className={cn(
                'col-12 my-1 p-0 fs-22 large-input row mx-0 justify-content-center roundedSm',
                activeElement === 'cardNumber'
                  ? 'border od-container-card-border border-color-primary'
                  : ''
              )}
            >
              <input
                value={getInput('cardNumber')}
                className={cn('form-control')}
                type="text"
                style={{
                  height: '10vh',
                }}
                id="cardNumber"
                name="cardNumber"
                onFocus={() => {
                  handleChangeInput('securityCode');
                  setActiveElement('cardNumber');
                  handleBlur();
                }}
                placeholder={CUSTOM_MESSAGES().ENTER_CARD_NUMBER}
              />

              {inputs?.cardNumber?.length > 0 && (
                <div
                  role="presentation"
                  className="position-absolute"
                  style={{
                    top: '50%',
                    right: '1%',
                    transform: 'translateY(-50%)',
                  }}
                  onClick={() => {
                    handleGiftCancel(false);
                    setEmpty('cardNumber');
                    setActiveElement('cardNumber');
                  }}
                >
                  <i
                    className="fa fa-times fs-24 od-text-secondary text-secondary"
                    aria-hidden="true"
                  />
                </div>
              )}
            </div>
            {giftCardMethods?.includes('ocr') && (
              <div className={cn('ml-2')} role="presentation" onClick={() => setIsWebCam(true)}>
                <i className={cn('fa fa-camera fa-2x')} fontSize="large" />
              </div>
            )}
          </div>

          {isSecurityCode && (
            <div
              className={cn(
                'col-12 my-1 p-0 fs-22 large-input row mx-0 justify-content-center roundedSm',
                activeElement === 'securityCode'
                  ? 'border od-container-card-border border-color-primary'
                  : ''
              )}
            >
              <input
                value={getInput('securityCode')}
                className={cn('form-control p-1')}
                type="text"
                style={{
                  height: '10vh',
                }}
                id="securityCode"
                name="securityCode"
                onFocus={() => {
                  handleChangeInput('securityCode');
                  setActiveElement('securityCode');
                  handleBlur();
                }}
                placeholder={CUSTOM_MESSAGES().ENTER_SECURITY_CODE}
              />
              {inputs?.securityCode?.length > 0 && (
                <div
                  role="presentation"
                  className="position-absolute"
                  style={{
                    top: '50%',
                    right: '1%',
                    transform: 'translateY(-50%)',
                  }}
                  onClick={() => {
                    handleGiftCancel(false);
                    setEmpty('securityCode');
                    setActiveElement('securityCode');
                  }}
                >
                  <i
                    className="fa fa-times fs-24 od-text-secondary text-secondary"
                    aria-hidden="true"
                  />
                </div>
              )}
            
            </div>
          )}
           <div className="d-flex mt-2 flex-column align-items-center pt-10" style={{height: '10vh'}}>
              <button
                type="submit"
                className={cn("col-12 btn70 btn btn-primary btn-ripple od-btn-primary text-uppercase", Styles.divForPayment)}
                disabled={handleDisable()}
                style={{height: '11vh', fontSize: isServerApp? "35px" : "1.8rem"}}
                onClick={() => {
                    onSubmit({ ...inputs, method: 'type' });
                    setSwipedDown(false);
                  }}
              >
                {LABEL().CHECK_BALANCE}
              </button>
            </div> 
          {giftBalanceAmt === 0 && (
            <div className="col-12 text-center text-primary fs-14 py-2">
              {giftBalanceAmt > 0 && (
                <>
                  {LABEL().BALANCE}: {currencySymbol}
                  {Number(giftBalanceAmt).toFixed(2)}
                </>
              )}
              <button
                type="button"
                className={cn('btn btn35 od-btn-primary btn-primary btn-ripple w-100', Styles.divForPayment)}
                onClick={() => handleGiftCancel('cancel')}
                style={{height: '5vh'}}
              >
                {LABEL().OTHER_OPTIONS}
              </button>
            </div>
          )}

          <div className={cn( isPaymentTerminal? 'col-12 row mt-5 align-items-center' : 'col-12 row my-3 align-items-center')}>
              <div className={cn('row col-12 od-text-primary my-2 text-primary fs-26', Styles.divForPayment )} > <div className='col-9' style={ isPaymentTerminal ?{ fontSize: '23px' } : {}}> {LABEL().BALANCE} </div> <div style={ isPaymentTerminal ?{ fontSize: '23px' } : {}} className='col-3'>{giftBalanceAmt >= 0 && currencySymbol}{  (giftBalanceAmt?.toFixed(2))}</div>  </div>
              <div className={cn('row col-12 od-text-primary my-2 text-primary fs-26', Styles.divForPayment )} style={ isPaymentTerminal ?{ fontSize: '23px' } : {}}> <div style={ isPaymentTerminal ?{ fontSize: '23px' } : {}} className='col-9'> {LABEL().APPLIED} </div>  <div style={ isPaymentTerminal ?{ fontSize: '23px' } : {}} className='col-3'>{giftBalanceAmt >= 0 && paymentAmount >= 0 && currencySymbol}{giftBalanceAmt >= 0 && paymentAmount?.toFixed(2)} </div></div>
          </div>  
          </div>
          
      </div>
      <div className="col-12" style={ isPaymentTerminal ? { bottom: '0', left: '0', marginTop: '9px' } : { bottom: '0', left: '0', marginTop: '10px' }}>
        <button
          type="submit"
          disabled={handleDisableApplyButton()}
          className={cn("col-12 btn70 btn btn-primary btn-ripple od-btn-primary text-uppercase", Styles.divForPayment)}
          style={{height: '10vh', fontSize: isServerApp? "35px" : "1.8rem"}}
          onClick={() =>  {
            if(paymentAmount > giftBalanceAmt){
              return giftCardPayment(giftBalanceAmt);
            } else {
              return giftCardPayment(paymentAmount);
            }
            }}
        >
          {giftBalanceAmt >= 0 && paymentAmount > giftBalanceAmt  ? LABEL().APPLY +' '+currencySymbol+giftBalanceAmt.toFixed(2) : (giftBalanceAmt >= 0 && paymentAmount < giftBalanceAmt) ? LABEL().APPLY +' '+currencySymbol+paymentAmount.toFixed(2) : LABEL().APPLY}
        </button>
      </div>
      <Modal isOpen={isWebCam} isModalCenter>
        <div className="p-2 justify-content-center align-items-center text-center">
          <div className={cn('px-2 text-right')}>
            <i
              role="presentation"
              className={cn('fa fa-times fs-24')}
              onClick={() => setIsWebCam(!isWebCam)}
            />
          </div>
          {isWebCam ? <WebcamCapture /> : <></>}
        </div>
      </Modal>
    </div>
  ) : (
    <>
      <div className="col-12 py-2">
        {giftBalance && (
          <div className="text-left fs-30">
            {LABEL().BALANCE} {currencySymbol}
            {giftBalance.toFixed(2)}
          </div>
        )}
        <div className="large-input my-2 position-relative">
          <input
            value={getInput('giftCard')}
            className={cn('form-control p-1')}
            type="text"
            style={{ height: '10vh', fontSize: '3vh' }}
            id="giftCard"
            name="giftCard"
            onFocus={() => {
              setActiveElement('giftCard');
              handleBlurForGift();
            }}
            placeholder=""
          />
          {inputs?.giftCard?.length > 0 && (
            <div
              role="presentation"
              className="position-absolute"
              style={{ right: '18px', top: '18px' }}
              onClick={() => {
                setEmpty('giftCard');
                setActiveElement('giftCard');
              }}
            >
              <i
                className="fa fa-times fs-24 od-text-secondary text-secondary"
                aria-hidden="true"
              />
            </div>
          )}
          <div className={cn('position-absolute', Styles.currencyDollar)}>
            {currencySymbol}
          </div>
          <div className="col-12 fs-12 text-center od-text-primary text-primary">
            {error}
          </div>
        </div>
        <CustomKeyboard
          onClickBtn={(e) => onClickBtn(e)}
          type="withoutDone"
          isDot
          typed={typed[activeElement] || ''}
          closeKeyboard={closeKeyboard}
          btnSize="btn80"
          customClass="fs-30 background-primary od-app-background-color"
          maxLength={activeElement === 'cardNumber' ? 20 : 10}
        />
      </div>
      <div className="col-12 w-100">
        <button
          type="submit"
          disabled={handleDisableGiftCard()}
          className={cn("col-12 btn70 btn btn-primary btn-ripple od-btn-primary", Styles.divForPayment)}
          onClick={() => validate()}
          style={{ marginTop : '150px',fontSize: isServerApp? "35px" : "17px" }}
        >
          {LABEL().CONTINUE}
        </button>
      </div>
    </>
  );
};

export default giftCard;
